/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * )
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_IRAIL_SCHEMA = Yup.object().shape({
    //general section Rules:
    startKm: Yup.number('Value should be number').integer("Number must be integer..").positive('Start KM should be positive..').nullable(true),
    endKm: Yup.number('Value should be number').integer("Number must be integer..").positive('End KM should be positive..').nullable(true),
    dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true),
    dateValidFor: Yup.string("Valid for is a Year"),
    tentTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    routeId: Yup.string("Route ID is alphanumeric").nullable(true),
    nationalRouteId: Yup.string("National Route ID is alphanumeric").nullable(true),
    internatRouteId: Yup.string("International Route ID is alphanumeric").nullable(true),
    startNodeName: Yup.string("Start Node Name ID is alphanumeric").nullable(true),
    endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),

    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
            if (value === null) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

            for (const email of emails) {
                if (!emailRegex.test(email.trim())) {
                    throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    startKmDirA: Yup.number("Start km Direction A").nullable(true),
    startKmDirB: Yup.number("Start km Direction B").nullable(true),
    endKmDirA: Yup.number("End km Direction A").nullable(true),
    endKmDirB: Yup.number("End km Direction B").nullable(true),
    remarks: Yup.string("remarks").nullable(true),
    railwaysImpPmDescDTO: Yup.object().shape({
        projectName: Yup.string('Value should be a text').nullable(true),
        typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
        length: Yup.number('Value should be number').nullable(true),
        totalCostCapex: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        estiImpDeadline: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    railwaysImpPmEligiTentDTO: Yup.object().shape({
        electrification: Yup.boolean().nullable(true),
        lineSpeed100KmFreight: Yup.boolean().nullable(true),
        axleLoad225T: Yup.boolean().nullable(true),
        trackGouge: Yup.boolean().nullable(true),
        trainLength740M: Yup.boolean().nullable(true),
        ertmsDeployEtcs: Yup.boolean().nullable(true),
        ertmsDeployGsmr: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        passengerDesignSpeed160: Yup.boolean().nullable(true),
        loadingGauge: Yup.boolean().nullable(true),
        maxDwellingTimeCrossBorder25: Yup.boolean().nullable(true),
        maxDelayCrossBorder: Yup.boolean().nullable(true),
        capacityBottlenecks: Yup.boolean().nullable(true),
        strongInclines: Yup.boolean().nullable(true)
    }),
    railwaysImpPmIndicatorsDTO: Yup.object().shape({
        siAnnTraffDemGro: Yup.string('Value should be a text').nullable(true),
        siModalTrans: Yup.string('Value should be a text').nullable(true),
        siAnnTraffAcciRateRed: Yup.string('Value should be a text').nullable(true),
        eiEirr: Yup.string('Value should be a text').nullable(true),
        eiNpv: Yup.number('Value should be number').nullable(true),
        eiSdr: Yup.string('Value should be a text').nullable(true),
        eiProjPlanDesCost: Yup.number('Value should be number').nullable(true),
        eiProjConstCost: Yup.number('Value should be number').nullable(true),
        eiTotalProjCost: Yup.number('Value should be number').nullable(true),
        fiFirr: Yup.string('Value should be a text').nullable(true),
        fiFnpv: Yup.number('Value should be number').nullable(true),
        fiFdr: Yup.string('Value should be a text').nullable(true),
        fiWacc: Yup.string('Value should be a text').nullable(true),
        fiFirtsYearProf: Yup.string('Value should be a text').nullable(true),
        fiDscr: Yup.string('Value should be a text').nullable(true),
        eniCo2Ems: Yup.string('Value should be a text').nullable(true),
        eniNoxEms: Yup.string('Value should be a text').nullable(true),
        eniSo2Ems: Yup.string('Value should be a text').nullable(true),
        eniNmhcEms: Yup.string('Value should be a text').nullable(true),
        eniPpm: Yup.string('Value should be a text').nullable(true),
        eniNoiseLevel: Yup.string('Value should be a text').nullable(true),
        eniCliChangeRes: Yup.string('Value should be a text').nullable(true),
        eniProteNatuaAff: Yup.number('Value should be number').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    railwaysImpPmPiDTO: Yup.object().shape({
        forecastConstPeriod: Yup.number('Value should be number').nullable(true),
        actualConstPeriod: Yup.number('Value should be number').nullable(true),
        forecastCapex: Yup.number('Value should be number').nullable(true),
        actualCapex: Yup.number('Value should be number').nullable(true),
        forecastOpex: Yup.number('Value should be number').nullable(true),
        actualOpex: Yup.number('Value should be number').nullable(true),
        forecastMaintCost: Yup.number('Value should be number').nullable(true),
        actualMaintCost: Yup.number('Value should be number').nullable(true),
        interestDuringConst: Yup.string('Value should be a text').nullable(true),
        ebitda: Yup.string('Value should be a text').nullable(true),
        forecastRevenue: Yup.number('Value should be number').nullable(true),
        actualRevenue: Yup.number('Value should be number').nullable(true),
        forecastTrainTraffic: Yup.string('Value should be a text').nullable(true),
        actualTrainTraffic: Yup.string('Value should be a text').nullable(true),
        forecastPassTraffic: Yup.string('Value should be a text').nullable(true),
        actualPassTraffic: Yup.string('Value should be a text').nullable(true),
        forecastFreightTn: Yup.string('Value should be a text').nullable(true),
        actualFreightTn: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    railwaysImpPmStatusDTO: Yup.object().shape({
        implemented: Yup.string('Value should be a text').nullable(true),
        ongoingProjFs: Yup.string('Value should be a text').nullable(true),
        matureProjFs: Yup.string('Value should be a text').nullable(true),
        projUnderPrep: Yup.string('Value should be a text').nullable(true),
        projStatusDesc: Yup.string('Value should be a text').nullable(true),
        initProjCompDate: Yup.date("Valid to is a Date").nullable(true),
        actualProjCompDate: Yup.date("Valid to is a Date").nullable(true),
        projFundNatBudg: Yup.string('Value should be a text').nullable(true),
        projFundWb: Yup.string('Value should be a text').nullable(true),
        projFundEbrd: Yup.string('Value should be a text').nullable(true),
        projFundEib: Yup.string('Value should be a text').nullable(true),
        otherIfi: Yup.string('Value should be a text').nullable(true),
        otherIfiSpec: Yup.string('Value should be a text').nullable(true),
        concessions: Yup.string('Value should be a text').nullable(true),
        concessionSpec: Yup.string('Value should be a text').nullable(true),
        euFund: Yup.string('Value should be a text').nullable(true),
        euFundSpec: Yup.string('Value should be a text').nullable(true),
        otherFund: Yup.string('Value should be a text').nullable(true),
        otherFundSpec: Yup.string('Value should be a text').nullable(true),
        projDocTitle: Yup.string('Value should be a text').nullable(true),
        projDocPrepBy: Yup.string('Value should be a text').nullable(true),
        projDocSupervBy: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    railwaysImpPmTentcompDTO: Yup.object().shape({
        electrificationBefProj: Yup.boolean().nullable(true),
        electrificationAftProjImp: Yup.boolean().nullable(true),
        befLineSpeed100Km: Yup.boolean().nullable(true),
        aftLineSpeed100Km: Yup.boolean().nullable(true),
        befAxleLoad225T: Yup.boolean().nullable(true),
        aftAxleLoad225T: Yup.boolean().nullable(true),
        befTrackGauge: Yup.boolean().nullable(true),
        aftTrackGauge: Yup.boolean().nullable(true),
        befTrainLength740M: Yup.boolean().nullable(true),
        aftTrainLength740M: Yup.boolean().nullable(true),
        befErtmsDeployEtcs: Yup.boolean().nullable(true),
        aftErtmsDeployEtcs: Yup.boolean().nullable(true),
        befErtmsDeployGsmr: Yup.boolean().nullable(true),
        aftErtmsDeployGsmr: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        befPassengerDesignSpeed160: Yup.string().nullable(true),
        aftPassengerDesignSpeed160: Yup.string().nullable(true),
        befLoadingGauge: Yup.string().nullable(true),
        aftLoadingGauge: Yup.string().nullable(true),
        befMaxDwellingTimeCrossBorder25: Yup.string().nullable(true),
        aftMaxDwellingTimeCrossBorder25: Yup.string().nullable(true),
        befMaxDelayCrossBorder: Yup.string().nullable(true),
        aftMaxDelayCrossBorder: Yup.string().nullable(true),
        befCapacityBottlenecks: Yup.string().nullable(true),
        aftCapacityBottlenecks: Yup.string().nullable(true),
        befStrongInclines: Yup.string().nullable(true),
        aftStrongInclines: Yup.string().nullable(true)
    }),
});

const IRAIL_INIT = {
    //general section Rules:
    startKm: 0,
    endKm: 0,
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    tentTCategory: "",
    routeId: "",
    nationalRouteId: "",
    internatRouteId: "",
    startNodeName: "",
    endNodeName: "",
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    startKmDirA: 0,
    startKmDirB: 0,
    endKmDirA: 0,
    endKmDirB: 0,
    targetTentSec: 0,
    newTentSec: 0,
    immedPartTentNet: false,
    remarks: "",
    railwaysImpPmDescDTO: {
        projectName: "",
        typeForeseenInterven: "",
        length: "",
        totalCostCapex: 0,
        estiImpDeadline: 0,
        remarks: "",
    },
    railwaysImpPmEligiTentDTO: {
        electrification: false,
        lineSpeed100KmFreight: false,
        axleLoad225T: false,
        trackGouge: false,
        trainLength740M: false,
        ertmsDeployEtcs: false,
        ertmsDeployGsmr: false,
        remarks: "",
        passengerDesignSpeed160: false,
        loadingGauge: false,
        maxDwellingTimeCrossBorder25: false,
        maxDelayCrossBorder: false,
        capacityBottlenecks: false,
        strongInclines: false,
    },
    railwaysImpPmIndicatorsDTO: {
        siAnnTraffDemGro: "",
        siModalTrans: "",
        siAnnTraffAcciRateRed: "",
        eiEirr: "",
        eiNpv: 0,
        eiSdr: "",
        eiProjPlanDesCost: 0,
        eiProjConstCost: 0,
        eiTotalProjCost: 0,
        fiFirr: "",
        fiFnpv: 0,
        fiFdr: "",
        fiWacc: "",
        fiFirtsYearProf: "",
        fiDscr: "",
        eniCo2Ems: "",
        eniNoxEms: "",
        eniSo2Ems: "",
        eniNmhcEms: "",
        eniPpm: "",
        eniNoiseLevel: "",
        eniCliChangeRes: "",
        eniProteNatuaAff: 0,
        remarks: "",
    },
    railwaysImpPmPiDTO: {
        forecastConstPeriod: 0,
        actualConstPeriod: 0,
        forecastCapex: 0,
        actualCapex: 0,
        forecastOpex: 0,
        actualOpex: 0,
        forecastMaintCost: 0,
        actualMaintCost: 0,
        interestDuringConst: "",
        ebitda: "",
        forecastRevenue: 0,
        actualRevenue: 0,
        forecastTrainTraffic: "",
        actualTrainTraffic: "",
        forecastPassTraffic: "",
        actualPassTraffic: "",
        forecastFreightTn: "",
        actualFreightTn: "",
        remarks: "",
    },
    railwaysImpPmStatusDTO: {
        implemented: "",
        ongoingProjFs: "",
        matureProjFs: "",
        projUnderPrep: "",
        projStatusDesc: "",
        initProjCompDate: "",
        actualProjCompDate: "",
        projFundNatBudg: 1,
        projFundWb: 1,
        projFundEbrd: 1,
        projFundEib: 1,
        otherIfi: 1,
        otherIfiSpec: "",
        concessions: 1,
        concessionSpec: "",
        euFund: 1,
        euFundSpec: "",
        otherFund: 1,
        otherFundSpec: "",
        projDocTitle: "",
        projDocPrepBy: "",
        projDocSupervBy: "",
        remarks: ""
    },
    railwaysImpPmTentcompDTO: {
        electrificationBefProj: false,
        electrificationAftProjImp: false,
        befLineSpeed100Km: false,
        aftLineSpeed100Km: false,
        befAxleLoad225T: false,
        aftAxleLoad225T: false,
        befTrackGauge: false,
        aftTrackGauge: false,
        befTrainLength740M: false,
        aftTrainLength740M: false,
        befErtmsDeployEtcs: false,
        aftErtmsDeployEtcs: false,
        befErtmsDeployGsmr: false,
        aftErtmsDeployGsmr: false,
        remarks: "",
        befPassengerDesignSpeed160: false,
        aftPassengerDesignSpeed160: false,
        befLoadingGauge: false,
        aftLoadingGauge: false,
        befMaxDwellingTimeCrossBorder25: false,
        aftMaxDwellingTimeCrossBorder25: false,
        befMaxDelayCrossBorder: false,
        aftMaxDelayCrossBorder: false,
        befCapacityBottlenecks: false,
        aftCapacityBottlenecks: false,
        befStrongInclines: false,
        aftStrongInclines: false
    },
}

export { TODIS_IRAIL_SCHEMA, IRAIL_INIT };